import React from "react";
import TabDistributorLedger from "./TabDistributorLedger";

type Props = {};

const TabDistributorLedgerWrapper = (props: Props) => {
  return (
      <TabDistributorLedger />
  );
};
export default TabDistributorLedgerWrapper
